function addToSearchHistory(searchTerm) {
    var searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
    if (searchHistory[0] !== searchTerm) {
        searchHistory.unshift(searchTerm);
        if (searchHistory.length > 8) {
            searchHistory = searchHistory.slice(0, 8);
        }
        localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
    }
}

function showSearchHistory() {
    let searches = JSON.parse(localStorage.getItem('searchHistory')) || [];
    let resultsContainer = $('.search_results_here');
    resultsContainer.empty();

    searches.forEach(function(search) {
        resultsContainer.append(`<div class="search-history-item">${search}</div>`);
    });

    if (searches.length === 0) {
        resultsContainer.append('<div class="search-history-item">No recent searches have been made.</div>');
    }

    resultsContainer.show();

}

$(document).on('click touchend', '.search-history-item', function(e) {
  if (e.type == "touchend") {
      e.stopPropagation();
      e.preventDefault();
  }

  let searchTerm = $(this).text();
  $('.search-input__').val(searchTerm);
  $('.search_results_here').hide();
  $('.search__button_custom').click();

});


function manageSearchInputFocus() {

    if (window.innerWidth >= 799) {

      $('.search-input__').on('focus', function() {
        showSearchHistory();
      });
    } else {

      $('.search-input__').off('focus');
    }
  }
  

  $(document).ready(manageSearchInputFocus);

  $(window).resize(manageSearchInputFocus);

function manageSearchFieldBehavior() {

    if (window.innerWidth <= 798) {
      const customSearchFields = document.querySelectorAll('.search-input__');
      const searchResults = document.querySelector('.search_results_here');
  
      function hideSearchResults() {
        searchResults.style.display = 'none';
      }
  
      function showSearchResults() {
          showSearchHistory();
      }
  
      customSearchFields.forEach(field => {
        field.addEventListener('click', function(event) {
          event.stopPropagation();
          showSearchResults();
        });
      });
  
      document.addEventListener('click', hideSearchResults);
  
      searchResults.addEventListener('click', function(event) {
        event.stopPropagation();
      });
    }
  }
  
  manageSearchFieldBehavior();

  window.addEventListener('resize', manageSearchFieldBehavior);
  
